export const SESSION_ALIVE_NEW_TOKEN = "SESSION_ALIVE_NEW_TOKEN"